import React, { Component } from 'react';
import { history,SVCMessage, CommonHelper } from '../../_helpers';
import { UserService } from '../../_services';
import { toastr } from 'react-redux-toastr';
import configJson from '../../_helpers/config.json';
const basePath= configJson["CommonConstants"]["Base_path"]
export default class LaunchLti extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    };

        componentDidMount() {
            let queryStrings = CommonHelper.getQueryStrings('&psvc&');
            let custom_BookCode = queryStrings.custom_BookCode;
            let custom_person_id = queryStrings.custom_person_id;
            // let custom_person_name = queryStrings.custom_person_name;
            let roles = queryStrings.roles;
        
        // let user = { custom_BookCode, custom_person_name, custom_person_id, roles };
        let user = { custom_BookCode, custom_person_id, roles };
        // if (custom_person_id && custom_person_name && roles && custom_BookCode) {
            if (custom_person_id && roles && custom_BookCode) {
            localStorage.clear();
            UserService.ltiGenerateToken(user).then(res => {
                history.push(basePath+'/');
            },
                error => {
                    toastr.error('Login', SVCMessage[error]);
                }
            );
        }
        //user allready login navigate to dashboard
        if (localStorage.getItem('user')) {
            this.props.history.push(basePath+"/");
        }
    };

  render() {
    return (
      <div>
       
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/lti/launch-lti.js